import React from "react";
import classes from "./productSort.shimmer.module.css";
import Shimmer from "../../components/Shimmer/shimmer";

const ProductSortShimmer = (props) => {
  return (
    <div className={classes.root} aria-live="polite" aria-busy="true">
      <Shimmer width={"146px"} height={"36px"} />
    </div>
  );
};

export default ProductSortShimmer;
